<div class="pe-calendar-header">
  <div class="filter-button-container">
    @for (opt of options; track opt) {
      <div
        class="toggleButton"
        [ngClass]="{ selected: selectedRange === opt.id }"
        (click)="quickRange(opt.id)"
        >
        {{ opt.label }}
      </div>
    }
  </div>

  <div class="month-row">
    <button mat-icon-button type="button" (click)="previousClicked()" aria-label="Previous month">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="month-label">{{ periodLabel }}</div>
    <button mat-icon-button type="button" (click)="nextClicked()" aria-label="Next month">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>

